// extracted by mini-css-extract-plugin
export default {"navLink":"icon-nav-link_navLink__ojB-y","purple":"icon-nav-link_purple__qdyX6","active":"icon-nav-link_active__vDsEd"};